import { UiGuideModel } from "../../models";

export function mockUiGuideModel({
    id = "Guide-1234",
    type = "uiGuide",
    locale = "en",
    content = mockUiGuideModelContent()
}: Partial<UiGuideModel> = {}): UiGuideModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiGuideModelContent = UiGuideModel["content"];

export function mockUiGuideModelContent({
    title = "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    chapters = [],
    ...optionals
}: Partial<UiGuideModelContent> = {}): UiGuideModelContent {
    return {
        title,
        chapters,
        ...optionals
    };
}
